import { Card, Divider, IconButton } from '@material-ui/core';
import { AddCircle, Warning } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/DeleteForeverOutlined';
import {
  Form
} from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { ORANGE, PERMISSIONS, PERMISSION_ENTITIES, RED } from '../../_config/consts.js';
import { elaborateForbiddenDaysString, hasFormWritePermission, isUserWithoutEmail } from '../../_config/utils.js';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import CalendarClockIconCustom from '../CustomIcons/CalendarClockIconCustom.jsx';
import SmartPhoneKeyIconCustom from '../CustomIcons/SmartPhoneKeyIconCustom.jsx';
import UsersIconCustom from '../CustomIcons/UsersIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import TagsSelectorListField from './Elements/TagsSelectorListField.jsx';
import CustomField from './Fields/CustomField.jsx';
import AdditionalTimeRangeForm from './TimeProfiles/AdditionalTimeRangeForm.jsx';
import DefaultTimeProfileForm from './TimeProfiles/DefaultTimeProfileForm.jsx';
import InfoSection from '../InfoSection/InfoSection.jsx';


const validate = (values) => {
  const errors = {};
  if (values) {
    if (!values.name) {
      errors.name = 'required';
    }
    
    if (!values.guestTags || (values.guestTags && _.isEmpty(values.guestTags))) {
      errors.guestTags = 'required';
    }

    if (!values.lockTags || (values.lockTags && _.isEmpty(values.lockTags))) {
      errors.lockTags = 'required';
    }

    if (!values.credentialTimeframe || !values.credentialTimeframe.startDate || !values.credentialTimeframe.endDate) {
      errors.credentialTimeframe = 'reservationDateIntevalErrorMessage';
    }

    if (!values.timeIntervalFrom) {
      errors.timeIntervalFrom = 'required';
    }

    if (!values.timeIntervalTo) {
      errors.timeIntervalTo = 'required';
    }
    if (values.timeIntervalTo && values.timeIntervalFrom) {
      const toTime = moment(values.timeIntervalTo);
      const fromTime = moment(values.timeIntervalFrom);
      const toDate = moment(0).hour(toTime.hour()).minute(toTime.minute()).second(0);
      const fromDate = moment(0).hour(fromTime.hour()).minute(fromTime.minute()).second(0);
      if (toDate.isSameOrBefore(fromDate)) {
        errors.timeIntervalTo = 'Interval not valid';
      }
    }
  }

  return errors;
};

@reduxForm({ form: 'CredentialForm', validate })
@connect(state => ({ form: state.form.CredentialForm, companyConfigurations: state.user.companyConfigurations }))
class CredentialForm extends React.Component {

  render() {
    const {
      form,
      availableLockTags,
      availableUserTags,
      onGuestTagsChange,
      onLockTagsChange,
      guestsFilteredByTags,
      locksFilteredByTags,
      onLockFilterModeChange,
      onGuestInputChange,
      onLockInputChange,
      onFetchMoreLocks,
      onFetchMoreGuests,
      onDeleteCredential,
      onGuestFilterModeChange,
      onCredentialFormSubmit,
      companyConfigurations,
      onInitializeNewTimeRange,
      is12HoursFormat,
    } = this.props;
    const canDeleteCredentialRule = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.DELETE], PERMISSION_ENTITIES.CREDENTIAL_RULE);
    const canReadUser = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.USER);
    const canReadLock = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK);
    const isEditing = form && form.values && form.values.id;
    const dateFrom = form && form.values && form.values.credentialTimeframe && form.values.credentialTimeframe.startDate;
    const dateTo = form && form.values && form.values.credentialTimeframe && form.values.credentialTimeframe.endDate;
    const timeFrom = form && form.values && form.values.timeIntervalFrom;
    const timeTo = form && form.values && form.values.timeIntervalTo;
    const dateIntervalTimeFrom = form && form.values && form.values.dateIntervalTimeFrom;
    const dateIntervalTimeTo = form && form.values && form.values.dateIntervalTimeTo;
    const daysString = form && form.values && form.values.daysOfTheWeek && elaborateForbiddenDaysString(form.values.daysOfTheWeek) ? elaborateForbiddenDaysString(form.values.daysOfTheWeek) : '';
    const usersSelected = form && form.values && form.values.selectedGuestTags;
    const usersHaveError = usersSelected ? _.find(usersSelected, user => isUserWithoutEmail(user)) : false;
    const credentialId = form && form.values.id ? form.values.id : null;
    return (
      <Form>
        <FormFlatContainer
          title="credentialData"
          headerStyle={{ marginBottom: 20 }}
          containerStyle={{ marginRight: 10, marginTop: 0 }}
          icon={<SmartPhoneKeyIconCustom style={{ width: 22, marginTop: 2 }} />}
        >
          <Entity
            componentClass={Field}
            name="name"
            componentAttribute="placeholder"
            entity="insertCredentialName"
            title={<Entity entity="credentialName" />}
            component={CustomField}
            type="text"
            disabled={!hasFormWritePermission(PERMISSION_ENTITIES.CREDENTIAL_RULE, isEditing)}
            mandatory
          />
          <Entity
            componentClass={Field}
            name="description"
            componentAttribute="placeholder"
            entity="insertDescription"
            title={<Entity entity="description" />}
            component={CustomField}
            disabled={!hasFormWritePermission(PERMISSION_ENTITIES.CREDENTIAL_RULE, isEditing)}
            type="text"
          />
        </FormFlatContainer>
        <FormFlatContainer
          title="credentialGuestTitle"
          subtitle="credentialTagGuestSubtitle"
          containerStyle={{ marginRight: 10 }}
          icon={<UsersIconCustom style={{ width: 22, marginTop: 2, marginRight: 0 }} />}
        >
          <TagsSelectorListField
            formName="CredentialForm"
            name="guestTags"
            selectorFieldName="guestTagMatchingMode"
            selectedTagsFieldName="selectedGuestTags"
            tags={availableUserTags}
            selectedTags={guestsFilteredByTags}
            form={form}
            tagsType="GUEST"
            title="usersTags"
            placeholder="insertGuestTagsForCredential"
            listTitle="selectedUsers"
            emptyTagSelectionText={canReadUser ? 'noUsersForSelectedTag' : null}
            onFetchMoreItems={page => onFetchMoreGuests(page)}
            onTagsChange={values => onGuestTagsChange(values)}
            onInputChange={value => onGuestInputChange(value)}
            itemHasErrorCondition={item => isUserWithoutEmail(item)}
            onFilterModeChange={values => onGuestFilterModeChange(values)}
            disabled={!hasFormWritePermission(PERMISSION_ENTITIES.CREDENTIAL_RULE, isEditing)}
          />
          {usersHaveError ? (
            <InfoSection
              title="selectedUsersNoEmailSmartphoneError"
              gravity="warning"
              titleStyle={{ fontWeight: 'normal' }}
            />
          ) : null}
        </FormFlatContainer>
        <FormFlatContainer
          title="defaultTimeProfileTitle"
          subtitle="defaultTimeProfileSubtitle"
          containerStyle={{ marginRight: 10 }}
          icon={<CalendarClockIconCustom style={{ width: 22 }} />}
        >
            <DefaultTimeProfileForm
              formData={form && form.values}
              form={form}
              formName="CredentialForm"
              is12HoursFormat={is12HoursFormat}
              onInitializeNewTimeRange={(timeRangeId, fieldName) => onInitializeNewTimeRange(timeRangeId, fieldName)}
              areDeviceDatesLocked={false}
              canEdit={hasFormWritePermission(PERMISSION_ENTITIES.CREDENTIAL_RULE, isEditing)}
              availableLockTags={availableLockTags}
              locksFilteredByTags={locksFilteredByTags && locksFilteredByTags[0]}
              onFetchMoreLocks={page => onFetchMoreLocks(page)}
              onLockTagsChange={values => onLockTagsChange(values)}
              onLockInputChange={value => onLockInputChange(value)}
              onLockFilterModeChange={values => onLockFilterModeChange(values)}
            />
        </FormFlatContainer>
        {isEditing && canDeleteCredentialRule &&
          <FormFlatContainer
            title="deleteCredential"
            subtitle="deleteCredentialWarning"
            containerStyle={{ marginRight: 10 }}
            icon={<DeleteIcon style={{ fontSize: 24, marginTop: 2, marginRight: 0 }} />}
          >
            <MDButton
              title={<Entity entity="deleteCredential" />}
              backgroundColor={RED}
              onClick={() => onDeleteCredential(credentialId)}
            />
          </FormFlatContainer>
        }
        {hasFormWritePermission(PERMISSION_ENTITIES.CREDENTIAL_RULE, credentialId) && (
          <div style={{ backgroundColor: 'white', position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}>
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              disabled={usersHaveError}
              onClick={() => onCredentialFormSubmit()}
            />
          </div>
        )}
      </Form>
    );
  }
} 

export default CredentialForm;
